import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getCustomerDocumentsV2 } from 'services/CustomerDocumentsServiceV2'

export const useGetCustomerDocumentsV2 = (customerReference: string) => {
  return useQuery({
    queryKey: reactQueryKeys.customerDocumentsV2(customerReference),
    queryFn: () => getCustomerDocumentsV2(customerReference),
    enabled: !!customerReference,
  })
}
